import type { EnvType, IEnvConfig } from '../types';
import { uxlabConfig } from './uxlab';
import { checkpointConfig } from './checkpoint';
import { sarosgameConfig } from './saros';

// 统一环境配置 Map
export const ENV_CONFIG_MAP: Record<EnvType, IEnvConfig> = {
  uxlab: uxlabConfig,
  checkpoint: checkpointConfig,
  saros: sarosgameConfig,
};

// 默认环境
export const DEFAULT_ENV: EnvType = 'uxlab';

